import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { Skeleton } from "~/components/ui/skeleton";
import { useEmployeePermissions } from "~/hooks/use-employee-permissions";
import { toConvexTableId } from "~/lib/convex-table-id";

import { VoidAndRefundsPage } from "../../../../components/voids-and-refunds/voids-and-refunds-page";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/voids-and-refunds"
)({
  component: VoidAndRefundsSettingsPage,
});

function VoidAndRefundsSettingsPage() {
  const { id } = Route.useParams();
  const { hasPermission, isLoading, hasEmployee } = useEmployeePermissions();
  const canViewAllOrders = hasPermission("viewAllOrders");

  // Loading state
  if (isLoading) {
    return <Skeleton className="h-96 w-full" />;
  }

  // No employee record linked
  if (!hasEmployee) {
    return (
      <Alert>
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>No Employee Profile</AlertTitle>
        <AlertDescription>
          Your account is not linked to an employee profile. Contact your
          organization admin to set up your employee record with the appropriate
          permissions.
        </AlertDescription>
      </Alert>
    );
  }

  // No permission to view voids and refunds
  if (!canViewAllOrders) {
    return (
      <Alert variant="destructive">
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>Access Denied</AlertTitle>
        <AlertDescription>
          You don't have permission to view voids and refunds. Contact your
          manager to request access.
        </AlertDescription>
      </Alert>
    );
  }

  return <VoidAndRefundsPage locationId={toConvexTableId("locations", id)} />;
}
